module.exports = __webpack_public_path__ + "static/media/md-cog.c952e3bb.svg";